<div class="sure__wrapper">
  <div class="sure__text">
    Are you sure you want to cancel account creation for
    {{ data.notification.fullName }}? You won't be able to create account after
    cancelling
  </div>
  <div class="sure__buttons">
    <button class="button button__cancel sure__button" (click)="notCancel()">
      No
    </button>
    <button class="button button__lightblue sure__button" (click)="cancel()">
      Yes
    </button>
  </div>
</div>
